export function codeChangeStats(file) {
  const added = Number(file?.parameters?.addedLines);
  const removed = Number(file?.parameters?.removedLines);
  if (!Number.isFinite(added) && !Number.isFinite(removed)) return null;
  return {
    added: Number.isFinite(added) ? added : 0,
    removed: Number.isFinite(removed) ? removed : 0,
  };
}

function splitLines(value) {
  if (value == null || value === '') return [];
  return String(value).replace(/\n$/, '').split('\n');
}

export function lineDiffParts(before, after) {
  const a = splitLines(before);
  const b = splitLines(after);
  const parts = [];
  let i = 0;
  let j = 0;
  while (i < a.length && j < b.length) {
    if (a[i] === b[j]) {
      parts.push({ value: `${a[i]}\n`, added: false, removed: false });
      i += 1;
      j += 1;
      continue;
    }
    const inB = b.indexOf(a[i], j);
    const inA = a.indexOf(b[j], i);
    if (inB !== -1 && (inA === -1 || (inB - j) <= (inA - i))) {
      while (j < inB) {
        parts.push({ value: `${b[j]}\n`, added: true, removed: false });
        j += 1;
      }
    } else if (inA !== -1) {
      while (i < inA) {
        parts.push({ value: `${a[i]}\n`, added: false, removed: true });
        i += 1;
      }
    } else {
      parts.push({ value: `${a[i]}\n`, added: false, removed: true });
      parts.push({ value: `${b[j]}\n`, added: true, removed: false });
      i += 1;
      j += 1;
    }
  }
  while (i < a.length) {
    parts.push({ value: `${a[i]}\n`, added: false, removed: true });
    i += 1;
  }
  while (j < b.length) {
    parts.push({ value: `${b[j]}\n`, added: true, removed: false });
    j += 1;
  }
  return parts;
}
